import { t } from 'utils/localize';

// tslint:disable: no-bitwise
export function positionsValueString(value: number) {
  const positions: string[] = [];

  if (value & 1) {
    positions.push(t('Self'));
  }
  if (value & 2) {
    positions.push(t('Lower Positions'));
  }
  if (value & 4) {
    positions.push(t('Same Positions'));
  }
  if (value & 8) {
    positions.push(t('Higher Positions'));
  }

  if (positions.length === 0) {
    return t('No One');
  } else if (positions.length === 4) {
    return t('Everyone');
  } else {
    return positions.join(', ');
  }
}
